import { baseURL } from "@/shared/http/api";

export default {
  getSharedLink: () => ({
    method: "GET",
    url: "api/v1/products/shared-link?product_id={product_id}&partner_id={partner_id}&parent_id={parent_id}",
    baseURL: baseURL,
    noPersist: true,
  }),
};
